// extracted by mini-css-extract-plugin
module.exports = {"root":"_6a4afb26569686a4b928d4bde9e227b8","root_button":"_6a8fb62eb8692bff8a0d3045100204c8"};